import { useState, useEffect } from 'react';
import { supabase, Database } from '../lib/supabase';

type DailyStreak = Database['public']['Tables']['daily_streaks']['Row'];

export function useDailyStreak(childId: string | null) {
  const [dailyStreak, setDailyStreak] = useState<DailyStreak | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchDailyStreak = async () => {
    if (!childId) {
      setDailyStreak(null);
      return;
    }

    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('daily_streaks')
        .select('*')
        .eq('child_id', childId)
        .single();

      if (error && error.code !== 'PGRST116') {
        throw error;
      }

      setDailyStreak(data || null);
    } catch (error) {
      console.error('Error fetching daily streak:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDailyStreak();
  }, [childId]);

  return {
    dailyStreak,
    loading,
    refetch: fetchDailyStreak,
  };
}